import User from "@views/moblie/user/User";

export default [
  {
    path: "/user",
    name: "User",
    meta: {
      title: "個人中心",
      keepAlive: true,
      footer: true,
      auth: true
    },
    component: User
  },
  {
    path: "/user/binding",
    name: "BindingPhone",
    meta: {
      title: "綁定手機",
      keepAlive: true,
      backgroundColor: "#fff",
      auth: true
    },
    component: () => import("@views/moblie/user/BindingPhone.vue")
  },
  {
    path: "/user/add_address/:id?",
    name: "AddAddress",
    meta: {
      title: "添加收貨地址",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/address/AddAddress.vue")
  },
  {
    path: "/user/account",
    name: "UserAccount",
    meta: {
      title: "我的賬戶",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/UserAccount.vue")
  },
  {
    path: "/user/add_manage",
    name: "AddressManagement",
    meta: {
      title: "地址管理",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/address/AddressManagement.vue")
  },
  {
    path: "/user/poster",
    name: "PosterUser",
    meta: {
      title: "學術海報",
      keepAlive: false,
      backgroundColor: "#a3a3a3",
      auth: true
    },
    component: () => import("@views/moblie/user/promotion/Poster.vue")
  },
  {
    path: "/user/sign",
    name: "Sign",
    meta: {
      title: "簽到",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/signIn/Sign.vue")
  },
  {
    path: "/user/sign_record",
    name: "SignRecord",
    meta: {
      title: "簽到記錄",
      keepAlive: true
    },
    component: () => import("@views/moblie/user/signIn/SignRecord.vue")
  },
  {
    path: "/user/cash",
    name: "UserCash",
    meta: {
      title: "添加醫生",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/promotion/UserCash.vue")
  },
  {
    path: "/user/audit",
    name: "CashAudit",
    meta: {
      title: "提現審核",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/promotion/CashAudit.vue")
  },
  {
    path: "/user/promoter_order",
    name: "PromoterOrder",
    meta: {
      title: "學術人訂單",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/promotion/PromoterOrder.vue")
  },
  {
    path: "/user/promoter_order_list/:type",
    name: "PromoterOrderList",
    meta: {
      title: "學術人訂單列表",
      keepAlive: true,
      auth: true
    },
    component: () =>
      import("@views/moblie/user/promotion/PromoterOrderList.vue")
  },
  {
    path: "/user/promoter_statistics/:type/:time?",
    name: "PromoterStatistics",
    meta: {
      title: "學術人訂單数据",
      keepAlive: true,
      auth: true
    },
    component: () =>
      import("@views/moblie/user/promotion/PromoterStatistics.vue")
  },
  {
    path: "/user/promoter_list",
    name: "PromoterList",
    meta: {
      title: "學術人列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/promotion/PromoterList.vue")
  },
  {
    path: "/user/user_promotion",
    name: "UserPromotion",
    meta: {
      title: "我的學術",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/promotion/UserPromotion.vue")
  },
  {
    path: "/user/bill/:types?",
    name: "UserBill",
    meta: {
      title: "賬單明細",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/UserBill.vue")
  },
  {
    path: "/user/cashrecord",
    name: "CashRecord",
    meta: {
      title: "提現記錄",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/promotion/CashRecord.vue")
  },
  {
    path: "/user/commission",
    name: "CommissionDetails",
    meta: {
      title: "佣金明細",
      keepAlive: true,
      auth: true
    },
    component: () =>
      import("@views/moblie/user/promotion/CommissionDetails.vue")
  },
  {
    path: "/user/integral",
    name: "Integral",
    meta: {
      title: "積分詳情",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/signIn/Integral.vue")
  },
  {
    path: "/user/vip",
    name: "UserVip",
    meta: {
      title: "會員中心",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/UserVip.vue")
  },
  {
    path: "/user/data",
    name: "PersonalData",
    meta: {
      title: "個人資料",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/PersonalData.vue")
  },
  {
    path: "/shops/index",
    name: "StoreList",
    meta: {
      title: "线下门店",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/shops/storeList.vue")
  },
  {
    path: "/user/user_coupon",
    name: "UserCoupon",
    meta: {
      title: "我的優惠券",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/coupon/UserCoupon.vue")
  },
  {
    path: "/user/user_exchange_coupon",
    name: "UserCoupon",
    meta: {
      title: "我的優惠券",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/coupon/UserExchangeCoupon.vue")
  },
  {
    path: "/user/process",
    name: "Process",
    meta: {
      title: "乐托品流程",
      keepAlive: true,
      auth: false
    },
    component: () => import("@views/moblie/user/Process.vue")
  },
  {
    path: "/user/get_coupon",
    name: "GetCoupon",
    meta: {
      title: "領取優惠券",
      keepAlive: true
    },
    component: () => import("@views/moblie/user/coupon/GetCoupon.vue")
  },
  {
    path: "/user/user_cash",
    name: "UserCash1",
    meta: {
      title: "添加醫生",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/promotion/UserCash.vue")
  },
  {
    path: "/user/doctor_audit",
    name: "DoctorAudit",
    meta: {
      title: "醫生審核",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/promotion/DoctorAudit.vue")
  },
  {
    path: "/user/group_number/:uid",
    name: "GroupNumber",
    meta: {
      title: "团队数量",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/promotion/GroupNumber.vue")
  },
  {
    path: "/user/group_sales/:type/:time/:uid?",
    name: "GroupSales",
    meta: {
      title: "团队销售",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/promotion/GroupSales.vue")
  },
  {
    path: "/user/group_orders/:type/:uid",
    name: "GroupOrderList",
    meta: {
      title: "團隊訂單列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/promotion/GroupOrders.vue")
  },
  {
    path: "/user/group_order/:uid",
    name: "GroupOrder",
    meta: {
      title: "團隊訂單",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/promotion/GroupOrderState.vue")
  },
  {
    path: "/customer/list/:productId?",
    name: "CustomerList",
    meta: {
      title: "客服列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/CustomerList.vue")
  },
  {
    path: "/user/Recharge",
    name: "Recharge",
    meta: {
      title: "餘額充值",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/Recharge.vue")
  },
  {
    path: "/user/promoter_rank",
    name: "PromoterRank",
    meta: {
      title: "學術人排行",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/promotion/PromoterRank.vue")
  },
  {
    path: "/user/doctor_list",
    name: "DoctorList",
    meta: {
      title: "医生列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/promotion/DoctorList.vue")
  },
  {
    path: "/user/commission/rank",
    name: "CommissionRank",
    meta: {
      title: "佣金排行",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/promotion/CommissionRank.vue")
  },
  {
    path: "/user/doctor_data",
    name: "DoctorData",
    meta: {
      title: "下級資料",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/promotion/DoctorData.vue")
  },
  {
    path: "/user/promote_router",
    name: "PromoteRouter",
    meta: {
      title: "推广路线",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/moblie/user/promotion/PromoteRouter.vue")
  },
  {
    path: "/user/user_tree",
    name: "UserTree",
    meta: {
      title: "用户树状图",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/moblie/user/promotion/UserTree.vue")
  },
  // {
  //   path: "/user/doctorService",
  //   name: "DoctorService",
  //   meta: {
  //     title: "咨询医生",
  //     keepAlive: false,
  //     home: false,
  //     auth: true
  //   },
  //   component: () => import("@views/moblie/user/DoctorService.vue")
  // },
  {
    path: "/user/about",
    name: "ContactUs",
    meta: {
      title: "聯繫我們",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/ContactUs.vue")
  },
  {
    path: "/user/feedback",
    name: "FeedBack",
    meta: {
      title: "意見反饋",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/FeedBack.vue")
  },
  {
    path: "/user/verify",
    name: "verifyStatus",
    meta: {
      title: "審核狀態",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/user/Status.vue")
  },
  {
    path: "/user/notice",
    name: "AboutAs",
    meta: {
      title: "用戶須知",
      keepAlive: true
    },
    component: () => import("@views/moblie/user/AboutAs.vue")
  },
  {
    path: "/user/promotion_plan",
    name: "PromotionPlan",
    meta: {
      title: "學術獎勵",
      keepAlive: true
    },
    component: () => import("@views/moblie/user/PromotionPlan.vue")
  }
];
